import { Card, Flex, Skeleton } from "antd";

export const MyRoutePageSkeleton = () => {
    return (
        <Flex vertical gap={16}>
            <Flex vertical gap={10}>
                <Skeleton.Input active style={{ width: "100%", height: 40 }} />
                <Skeleton.Input active style={{ width: "100%", height: 32 }} />
            </Flex>

            <Flex vertical gap={8}>
                {Array.from({ length: 5 }).map((_, i) => (
                    <Card key={i} styles={{ body: { padding: 12 } }}>
                        <Flex justify="space-between" align="center">
                            <Flex vertical gap={6} style={{ flex: 1 }}>
                                <Skeleton.Input
                                    active
                                    style={{ width: "60%", height: 16 }}
                                />
                                <Skeleton.Input
                                    active
                                    style={{ width: "90%", height: 14 }}
                                />
                                <Skeleton.Input
                                    active
                                    style={{ width: "40%", height: 14 }}
                                />
                            </Flex>

                            <Skeleton.Button
                                active
                                style={{ width: 24, height: 24, minWidth: 24 }}
                            />
                        </Flex>
                    </Card>
                ))}
            </Flex>
        </Flex>
    );
};
